import { render, staticRenderFns } from "./QuickTipsCanceledRecordReport.vue?vue&type=template&id=483bea84&"
import script from "./QuickTipsCanceledRecordReport.vue?vue&type=script&lang=js&"
export * from "./QuickTipsCanceledRecordReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports